import React, { Component } from "react";
import { Link } from "react-router-dom";
import Table from "../common/table/table";

class UsersTable extends Component {
  columns = [
    {
      key: "edit",
      className: "col-1",
      content: user => (
        <Link to={`/users/${user.id}`} className="btn btn-info btn-sm">
          <i className="fa fa-edit" />
        </Link>
      )
    },
    {
      key: "delete",
      className: "col-1",
      content: user => (
        <button
          onClick={() => this.props.onDelete(user)}
          className="btn btn-danger btn-sm"
        >
          <i className="fa fa-trash" />
        </button>
      )
    },
    { key: "name", label: "Name", className: "col-4" },
    { key: "email", label: "e-mail", className: "col-6" },
    { key: "addInf", label: "Add. Inf.", className: "col-12" }
  ];

  render() {
    const { users, onSort, sortColumn } = this.props;

    return (
      <div className="container">
        <Table
          columns={this.columns}
          sortColumn={sortColumn}
          onSort={onSort}
          data={users}
        />
      </div>
    );
  }
}

export default UsersTable;



// WEBPACK FOOTER //
// ./src/components/users/usersTable.jsx